<template lang="pug">
Table(stripe :columns="columns" :data="value")
    
</template>
<script>
import { _dateFormat } from "@/libs/dateformat.js";
export default {
    name: "resourceUsageItemHistory",
    props: {
        value: [],
    },
    data() {
        return {
            columns: [
                {
                    title: "Item Name",
                    key: "itemName",
                    align: "center",
                },
                {
                    title: "Created Date",
                    key: "createdDate",
                    align: "center",
                },
            ],
            data: [],
        };
    },
    computed: {},
    methods: {},
    mounted() {
        this.data = this.value.map((e) => {
            e.createdDate = _dateFormat(e.createdDate, "YYYY-MM-DD HH:mm:ss");
            return e;
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/components/resourceUsageItemHistory.vue